import { Component, VModel, Vue } from 'vue-property-decorator';
import blankImage from '@/assets/images/blankImage.png';
import { isEmpty } from 'lodash';

@Component
export default class RequestApproveDialog extends Vue {
  @VModel() requestApproveDialogShown!: boolean;

  $refs!: {
    formRef: HTMLFormElement;
  };

  private invoiceImage: File | null = null;
  private previewImageURLTemp = '';
  private ruleOptions = {
    image: [() => this.isImageValid() || 'Image must be PNG, JPG or JPEG']
  };
  private acceptedImgTypes = ['image/png', 'image/jpg', 'image/jpeg'];

  isImageValid(): boolean {
    const { invoiceImage } = this;
    return !!invoiceImage && this.acceptedImgTypes.includes(invoiceImage.type);
  }

  get previewImage(): string {
    const { invoiceImage } = this;
    if (invoiceImage) {
      this.revokePreviewURL();
      this.previewImageURLTemp = URL.createObjectURL(invoiceImage);
      return this.previewImageURLTemp;
    }
    return blankImage;
  }

  revokePreviewURL(): void {
    if (!isEmpty(this.previewImageURLTemp)) {
      URL.revokeObjectURL(this.previewImageURLTemp);
    }
  }

  resetForm(): void {
    this.$refs.formRef.reset();
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  onCancelChange(): void {
    this.requestApproveDialogShown = false;
  }

  onConfirmChange(): void {
    if (this.formValidate()) {
      this.$emit('onConfirm', this.invoiceImage);
    }
  }
}
